<template>
  <div class="home">

    <dashboard/>
  </div>
</template>

<script>
import dashboard from "@/components/ContinueIssuance.vue";

export default {
  name: "ContinueIssuance",
  components: {
    dashboard
  }
};
</script>
